import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { VStack } from "native-base";
import CryptoJS from "crypto-js";
import Dropdown from "../../../../../components/dropdown";
import InputField from "../../../../../components/input";
import FileUploader from "../../../../../containers/fileUpload";
import {
  eventListingAPI,
  newEventListingAPI,
} from "../../../../../api/apis/event";
import { Toaster } from "../../../../../components/toaster";
import { getWorkflowAPI } from "../../../../../api/apis/workflow";
import SearchableSelectDropdown from "../../../../../components/searchableDropDown";
import config from "../../../../../utils/config";

export const TravelWallet = forwardRef(
  (
    {
      selectedTravelValue,
      // setSelectedValue,
      isEvent = false,
      eventDetails = false,
      forceRemount,
      showModal,
    },
    ref
  ) => {
    const toaster = Toaster();
    const [eventOptions, setEventOptions] = useState([]);
    const bytes = CryptoJS.AES.decrypt(
      sessionStorage.getItem("content"),
      config.userKey
    );
    const jsonString = bytes.toString(CryptoJS.enc.Utf8);
    const userInfo = JSON.parse(jsonString);
    const [selectedValue, setSelectedValue] = useState({
      type: "",
      event: "",
      document_name: "",
      documents: "",
    });
    const options = [
      { id: "1", value: "general", label: "General" },
      {
        id: "2",
        value: isEvent ? "event" : "mice",
        label: isEvent ? "Event" : "Mice",
      },
    ];

    useEffect(() => {
      AddWorkflow();
    }, [isEvent]);

    useEffect(() => {
      if (showModal) setSelectedValue(selectedTravelValue);
      else
        setSelectedValue({
          type: "",
          event: "",
          document_name: "",
          documents: "",
        });
    }, [showModal]);

    const onFileChange = (file) => {
      let fileData = { ...selectedValue };
      fileData.documents = file;
      setSelectedValue(fileData);
    };

    const onInputChange = (e, eName) => {
      if (eName === "event") setSelectedValue({ ...selectedValue, event: e });
      else if (eName === "type")
        setSelectedValue({ ...selectedValue, type: e });
      else if (eName === "document_name")
        setSelectedValue({ ...selectedValue, document_name: e.target.value });
    };

    const AddWorkflow = async () => {
      let res = await getWorkflowAPI();
      if (res.error) {
        toaster(res.message, "error", "error");
        return;
      } else {
        let workflows = {};
        res?.data?.data?.data?.map((item) => {
          if (item.name === "EventWorkflow") {
            workflows["event"] = item;
          }
        });
        if (workflows && workflows["event"] && workflows["event"]["_id"])
          getEventList(workflows["event"]["_id"]);
      }
    };

    const getEventList = async (workflow_id) => {
      let allEvents = [];
      let res = await newEventListingAPI(
        isEvent ? "event" : "mice",
        "1",
        "10000",
        "upcoming",
        userInfo.role !== "admin" ? userInfo.email : "",
        "home"
      );
      if (res.error) {
        toaster(res.message, "error", "error");
        return;
      } else {
        res?.data?.data?.data[0]?.events?.map((item) => {
          allEvents.push({
            id: item._id,
            value: item._id,
            label: item.event_name,
          });
        });
      }
      setEventOptions(allEvents);
    };

    const onSubmitDataInput = () => {
      return selectedValue;
    };

    useImperativeHandle(ref, () => ({
      onSubmitDataInput,
    }));

    return (
      <VStack>
        <VStack space={4}>
          {!eventDetails && (
            <>
              <Dropdown
                name="type"
                isDisabled={eventDetails}
                dropItems={options}
                defaultValue={
                  selectedTravelValue.type === ""
                    ? selectedValue.type
                    : selectedTravelValue.type
                }
                selectedValues={selectedValue.type}
                setSelectedValues={onInputChange}
                placeholder="Doc/General Type"
                width="100%"
              />
              {selectedValue.type ? (
                selectedValue.type === "event" ? (
                  <Dropdown
                    name="event"
                    dropItems={eventOptions}
                    defaultValue={
                      eventDetails
                        ? selectedTravelValue.id === ""
                          ? selectedValue.id
                          : selectedTravelValue.id
                        : selectedTravelValue.event === ""
                        ? selectedValue.event
                        : selectedTravelValue.event
                    }
                    selectedValues={selectedValue.event}
                    setSelectedValues={onInputChange}
                    placeholder="Event"
                    width="100%"
                  />
                ) : (
                  selectedValue.type === "mice" && (
                    <Dropdown
                      name="event"
                      dropItems={eventOptions}
                      defaultValue={
                        eventDetails
                          ? selectedTravelValue.id === ""
                            ? selectedValue.id
                            : selectedTravelValue.id
                          : selectedTravelValue.event === ""
                          ? selectedValue.event
                          : selectedTravelValue.event
                      }
                      selectedValues={selectedValue.event}
                      setSelectedValues={onInputChange}
                      placeholder="MICE"
                      width="100%"
                    />
                  )
                )
              ) : (
                <></>
              )}
            </>
          )}
          <InputField
            name="document_name"
            placeholder="Document Name"
            value={
              selectedTravelValue.document_name === ""
                ? selectedValue.document_name
                : selectedTravelValue.document_name
            }
            onChange={onInputChange}
            forceRemount={forceRemount}
          />
        </VStack>
        <FileUploader
          files={selectedValue.documents}
          setFiles={onFileChange}
          // accept={["jpg", "jpeg", "png", "pdf", "mp4"]}
          // types=".jpg, .jpeg, .png, .pdf, .mp4"
          accept={["jpg", "jpeg", "png", "pdf"]}
          types=".jpg, .jpeg, .png, .pdf"
          forceRemount={forceRemount}
        />
      </VStack>
    );
  }
);
